import { toast } from 'react-toastify';

const toastBodyClassName = 'toast-notification-body';
export default {
  info: (message) => {
    toast.info(message, {
      className: 'toast-notification-info',
      bodyClassName: toastBodyClassName,
    });
  },

  success: (message) => {
    toast.success(message, {
      className: 'toast-notification-success',
      bodyClassName: toastBodyClassName,
    });
  },

  error: (message) => {
    toast.error(message, {
      className: 'toast-notification-error',
      bodyClassName: toastBodyClassName,
    });
  },

  warning: (message) => {
    toast.warn(message, {
      className: 'toast-notification-warning',
      bodyClassName: toastBodyClassName,
    });
  },

  default: (message) => {
    toast(message, {
      bodyClassName: toastBodyClassName,
    });
  },
};
